import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

import AccountResources from './../../Account/Resources/commonfunctions.js'; //Account

let service = new services();
export default {
    name: 'Home',
    mixins: [AccountResources],
    data () {
        return {
            header_data:{},
            user:{},
            loggedIn: false,
            loading: true,
            tab_view: {},
            menu_tab_view:{},
            set_view:false,
            img_product_url: service.imageProductsURL,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                //this.setComponent('reset-edit','');
            }else{
                //this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
            //
            if(view == "viewTransfer"){
                this.transfer = attr1;
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                }else {
                    self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setPageCalls(){
            this.getBusinessProcessingFeesTransactions();
            //get business collections
            var payload = {
                data_module: 3,
                data_module_id:this.sellpoint.business_id
            }
            this.getCollections(payload);
        }
        
    },
    created: function(){
        if(this.$route.path == '/agentservices'){
            this.preset();
            this.header_data.name = "Agent Services";
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/AgentServices/Template/script.js